export default function Header({title, count}) {
  return (
    <div className="w-[25%] flex border-solid border-b-2 border-slate-200 px-2 pb-2">
      <div className="w-[80%] font-medium text-sm">{title}</div>
      <div className="w-[20%] text-right text-sm">
        {"(" + count + ")"}
      </div>
    </div>
  );
}
